import { TopicService } from './topic.service'
import { Project } from './project'
import { SearchTerm } from './search-term'

export class Topic {
  isNew: boolean
  searchTerms = new Map<string, SearchTerm>()
  dbRecords = new Map<string, [string, string]>() //dbRecordId, note
  private _title: string

  constructor(private topics: TopicService,
    public project: Project,
    public id: string,
    title: string) {
      this._title = title
    this.isNew = title == ''
    this.project.topicsMap.set(this.id, this)
  }

  set title(txt) {
    this._title = txt.trim()
  }

  get title() {
    return this._title
  }

}



// WEBPACK FOOTER //
// ./src/app/topic.ts